import request from '@/utils/request';
/* 修改密码 */
export function updateSeleniumJourneyPassword (data) {
  return request({
    url: '/selenium/journey/base/updateSeleniumJourneyPassword',
    method: 'POST',
    data
  });
}
/* 获取基地明细 */
export function getSeleniumJourneyBaseDetail (data) {
  return request({
    url: '/selenium/journey/base/getSeleniumJourneyBaseDetail',
    method: 'POST',
    data
  });
}
/* 修改基地基础信息 */
export function updateSeleniumJourneyBaseInfo (data) {
  return request({
    url: '/selenium/journey/base/updateSeleniumJourneyBaseInfo',
    method: 'POST',
    data
  });
}
/* 新增基地配置 */
export function saveSeleniumJourneyConfig(data) {
  return request({
    url: '/selenium/journey/config/saveSeleniumJourneyConfig',
    method: 'POST',
    data
  });
}
/* 获取基地配置明细 */
export function fetchSeleniumJourneyConfigDetail(data) {
  return request({
    url: '/selenium/journey/config/fetchSeleniumJourneyConfigDetail',
    method: 'POST',
    data
  });
}
/* 配送列表 */
export function deliveryList(data) {
  return request({
    url: '/selenium/freight/template/querySeleniumFreightTemplatePageList',
    method: 'POST',
    data
  });
}
/* 删除配送 */
export function deliveryDel(data) {
  return request({
    url: '/selenium/freight/template/removeSeleniumFreightTemplateById',
    method: 'POST',
    data
  });
}
/* 新增配送 */
export function deliveryAdd(data) {
  return request({
    url: '/selenium/freight/template/saveSeleniumFreightTemplate',
    method: 'POST',
    data
  });
}
/* 编辑配送 */
export function deliveryEdit(data) {
  return request({
    url: '/selenium/freight/template/updateSeleniumFreightTemplate',
    method: 'POST',
    data
  });
}
/* 配送信息显示 */
export function deliveryInfo(data) {
  return request({
    url: '/selenium/freight/template/fetchSeleniumFreightTemplateDetailById',
    method: 'POST',
    data
  });
}
/* 新增或修改商品配置 */
export function saveOrUpdateGoodsConfig(data) {
  return request({
    url: '/config/saveOrUpdateGoodsConfig',
    method: 'POST',
    data
  });
}
/* 获取商品配置数据 */
export function fetchGoodsConfigDetail(data) {
  return request({
    url: '/config/fetchGoodsConfigDetail',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/journeySetting.js